import { DateTime, Duration } from 'luxon'

import { Data } from '../../../../domain'
import { getStartOfDay } from '../../../../util/date'
import { required } from '../helpers'
import { ValidationFunctions } from '../types'

export const date: ValidationFunctions = {
  _self: {
    required,
    afterOrEqual: (option: string) => (value: string) =>
      DateTime.fromISO(value) >= getStartOfDay().plus(Duration.fromISO(option)),
    beforeOrEqual: (option: string) => (value: string) =>
      DateTime.fromISO(value) <= getStartOfDay().plus(Duration.fromISO(option)),
  },
  date: {
    afterOrEqual:
      (option: string, formKey: string) => (value: string, formValues: Data) =>
        DateTime.fromISO(formValues[formKey]) >=
        DateTime.fromISO(value).plus(Duration.fromISO(option)),
    beforeOrEqual:
      (option: string, formKey: string) => (value: string, formValues: Data) =>
        DateTime.fromISO(formValues[formKey]) <=
        DateTime.fromISO(value).plus(Duration.fromISO(option)),
  },
  yearMonth: {
    afterOrEqual:
      (option: string, formKey: string) => (value: string, formValues: Data) =>
        DateTime.fromISO(formValues[formKey]) >=
        DateTime.fromISO(value).plus(Duration.fromISO(option)),
    beforeOrEqual:
      (option: string, formKey: string) => (value: string, formValues: Data) =>
        DateTime.fromISO(formValues[formKey]) <=
        DateTime.fromISO(value).plus(Duration.fromISO(option)),
  },
  monthsRange: {
    withinRange:
      (_option: boolean, formKey: string) =>
      (value: string, formValues: Data): boolean => {
        if (!value || !formValues[formKey]) return true

        const policyStartDate = DateTime.fromISO(value)
        if (!policyStartDate.isValid) return true

        const season = formValues[formKey] as {
          from?: number
          to?: number
        }

        const { from, to } = season || {}

        if (!from || !to) return true

        const policyMonth = policyStartDate.month

        if (from <= to) {
          return policyMonth >= from && policyMonth <= to
        }

        return policyMonth >= from || policyMonth <= to
      },
  },
}
